import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=0b7dfb42&scoped=true"
import script from "./Legend.vue?vue&type=script&lang=ts"
export * from "./Legend.vue?vue&type=script&lang=ts"
import style0 from "./Legend.vue?vue&type=style&index=0&id=0b7dfb42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7dfb42",
  null
  
)

export default component.exports